import { CurrencySymbols } from '@infra/utils';

export const getCurrencySymbol = (currency: string | null | undefined) => {
  if (!currency) return '';
  switch (currency.toUpperCase()) {
    case 'USD':
      return CurrencySymbols.USD;
    case 'TRY':
      return CurrencySymbols.TRY;
    case 'AZN':
      return CurrencySymbols.AZN;
    case 'AVRO':
      return CurrencySymbols.EURO;
    default:
      return currency;
  }
};
